import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import Sticky from 'Components/Sticky';
import ActionLoader from 'Components/ActionLoader';
import Checkbox from 'Components/Checkbox';
import Overlay from 'Components/Overlay';
import Upload from 'Components/Upload';
import Tabs from 'Components/Tabs';

import { ReactComponent as DropdownIcon } from 'Icons/download-white.svg';
import { ReactComponent as UploadIcon } from 'Icons/upload-blue.svg';

import { POST_MARKET_RATE_REPORT, GET_REPORT_TEMPLATE, GET_MARKET_REPORT_LOCATIONS, TOAST_ERROR } from 'Constants/actionConstants';
import { getUser } from 'Utils/storage';
import Select from 'react-select';


class MarketAnalysisReportAccounts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            showReport: false,
            showDisclaimer: true,
            isCompanyDataReqd: false,
            file: null,
            tab: 1,
            fromLoc: [],
            toLoc: [],
        }
    }

    componentDidMount() {
        this.getLocations();
    }

    onFileChange = (file) => {
        this.setState({ file });
    }

    getReport = () => {
        const { dispatch } = this.props;
        const { file, toLoc, fromLoc, isCompanyDataReqd } = this.state;

        if ((toLoc.length === 0 || fromLoc.length === 0) && file===null) {
            dispatch({
                type: TOAST_ERROR,
                message: "Please upload file or select filters"
            });
            return;
        }

        this.setState({ isLoading: true });
        dispatch({
            type: POST_MARKET_RATE_REPORT,
            file: file,
            params: {
                exclude_current_customer_data: isCompanyDataReqd,
                report_type: 'market_rate_report',
                module: 'contracting',
            },
            data: {
                to: toLoc.map((el) => { return el.value }),
                from: fromLoc.map((el) => { return el.value })
            },
            onSuccess: (() => {
                this.setState({ file: null });
            })
        });
    }

    getReportTemplate = () => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_REPORT_TEMPLATE,
            data: '?excel_type=market_rate_report',
            onSuccess: ((data) => {
                let hiddenElement = document.createElement('a');
                hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(data);
                hiddenElement.target = '_blank';
                hiddenElement.download = `Market Report Template`;
                hiddenElement.click();
            })
        });
    }

    getLocations = () => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_MARKET_REPORT_LOCATIONS,
            // data: 
        })
    }

    selectedTab = (tab)=> {
        this.setState({ tab });
    }

    render() {
        const { history, reportsTabs, reportLocations } = this.props;
        const { isCompanyDataReqd, showDisclaimer, showReport, file, tab, fromLoc, toLoc } = this.state;
        const user = getUser();
        // (reportsTabs || []).map((el, index) => { el.id = index+1; el.value = el.report_name });
        const tabItem = (reportsTabs || []).filter(el => el.id===tab);

        return (
            <Sticky>
                { this.state.isLoading && <ActionLoader /> }
                {
                    showDisclaimer &&
                    <Overlay>
                        <div className="bg-white box-shadow ph-20 pv-20 br-5">
                            <div className="mb-10 tCenter header-medium-color fBold fs-20"> Disclaimer </div>
                            <div className="fs-14 lh-10p tJustify">
                                <div className="mb-15"> The Monthly Market Rates' (MMR) is derived by a computer driven mathematical model in reliance on available data on 'TransportEG' platform, without the verification of actual transactions and without taking into account the actual market conditions and/or aspects which may, together or separately, affect the rates prevailing in the market at any time.</div>
                                <div className="mb-15"> MMR must not be relied upon as a professional advice or as an accurate representation of the market rates. Caliper expressly excludes any warranties and representations that an MMR is an accurate representation as to the market rate.  The report is made available for download only as a reference point for the period of request and cannot be construed as exact market situation.</div>
                                <div className="mb-15"> MMR provided in this publication is of a general nature and should not be construed as specific advice or relied upon in lieu of appropriate professional advice. While Caliper uses commercially reasonable efforts to ensure the Data is current, Caliper does not warrant the accuracy, currency or completeness of MMR. </div>
                            </div>
                            <div className="col-1 ht-60 flex flex-middle flex-center bg-white">
                                <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={() => { this.setState({ showDisclaimer: false, showReport: true }); }}>Agree</button>
                                <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30" onClick={() => { history.push('/seeker'); }}>Disagree</button>
                            </div>
                        </div>    
                    </Overlay> 
                }
                <div className="mt-10 tRight">
                <button className="ht-25 br-20 white-color bg-theme fs-14 fBold pl-20 pr-20 mr-30" onClick={this.getReportTemplate}> <DropdownIcon />  Download Template</button>
                </div>
                <div className='flex flex-center mt-20'>
                    <Upload onChange={this.onFileChange}>
                        <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" > <UploadIcon /> Upload</button>
                        {file && <div className="fs-12"> {file.name} </div>}
                    </Upload>
                    <Select isMulti className={'wt-200 mr-20'}
                        placeholder="Select From"
                        options={reportLocations && reportLocations.from ? (reportLocations.from || []).map(el => { return {value: el, label: el } }) : []}
                        value={fromLoc}
                        onChange={(value) => { this.setState({ fromLoc: value }) }}
                    />
                    <Select isMulti className={'wt-200 mr-20'}
                        placeholder="Select To"
                        options={reportLocations && reportLocations.to ? (reportLocations.to || []).map(el => { return {value: el, label: el } }) : []}
                        value={toLoc}
                        onChange={(value) => { this.setState({ toLoc: value }) }}
                    />
                    <Checkbox label={`Exclude ${user.companyName || ''} Data`} checked={isCompanyDataReqd} className="mr-20" onCheck={() => { this.setState({ isCompanyDataReqd: !isCompanyDataReqd }); }} />
                    <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.getReport}>Submit</button>
                </div>

                {(reportsTabs || []).length > 1 &&
                    <div className="mt-20">
                    {(reportsTabs || []).map((report, ind) => {
                        return (
                            <Tabs key={(ind+1)} selectTab={this.selectedTab} activeTabId={tab} tabs={reportsTabs}/>
                        )
                    })}
                    </div>
                }

                {tabItem.length > 0 && 
                    // token && showReport &&
                    <iframe
                        src={"https://secure.holistics.io/embed/" + tabItem[0].embed_code + "?_token=" + tabItem[0].token}
                        style={{ width: "100%", height: 600 }}
                        frameBorder="0"
                        title={tabItem[0].report_name} //"Market Analysis Report"
                        onLoad={() => { this.setState({ isLoading: false }) }}
                        allowFullScreen>
                    </iframe>
                }
            </Sticky>
        );
    }
}

const mapStateToProps = ({constants}) => {
  return {
    // token: constants.holistics.token,
    // embedCode: constants.holistics.embedCode,

    reportsTabs: constants.reportsTabs,
    reportLocations: constants.reportLocations,
  }
};


export default connect(mapStateToProps)(withRouter(MarketAnalysisReportAccounts));
